import { Input } from "@ad/anq-ui";
import { InputProps } from "@ad/anq-ui/lib/input";
import React from "react";
import numeral from "numeral";
import BigNumber from "bignumber.js";

interface Props extends Omit<InputProps, "value" | "onChange"> {
  /** 保留2位小数的字符串格式的数字*/
  value?: string;
  onChange?: (v: string) => void;
}

/** 移除输入中的无效字符; 只允许1个小数点; 移除小数点后第3位开始的字符 */
export const formatInputString = (v: string) => {
  return v
    .replace(/[^0-9.]/g, "")
    .replace(/(\..*)\./g, "$1")
    .replace(/(\..{2}).*/g, "$1");
};

export const formatNumber = (v: string | number) => {
  return v ? numeral(v).format("0,0.00") : "";
};

/** 根据输入框中的字符串获取对应的数字 */
export const getNumber = (v: string) => {
  return BigNumber(Number(v.replace(/,/g, ""))).toNumber();
};

/**
 * 输入价格, 失焦后自动格式化为 0,0.00
 * @notice 在Number.MAX_SAFE_INTEGER附近可能会出现精度问题
 */
const InputMoney = ({ value, onChange, ...inputProps }: Props) => {
  const handleChange = (v: string) => {
    const formatRes = formatInputString(v);

    if (Number(formatRes) > Number.MAX_SAFE_INTEGER) {
      return;
    }
    onChange(formatRes);
  };

  return (
    <Input
      {...inputProps}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      onFocus={(e) => onChange(formatInputString(e.target.value))}
      onBlur={(e) =>
        e.target.value ? onChange(formatNumber(e.target.value)) : onChange("")
      }
    />
  );
};

export default InputMoney;
